import React, { Suspense, useEffect } from "react";
import { Main } from "@bbnpm/bb-ui-framework";
import { Outlet, useRouteLoaderData, useLocation } from "react-router";
import { Header } from "./header";
import { Loading } from "./loading";
import { Content } from "./content";
import { Footer } from "./footer";
import type { User } from "../api/bsso";
import { AuthProvider } from "../utility/auth";

export const Page: React.FC = () => {
  const user = useRouteLoaderData("root") as User | null;
  const location = useLocation();

  useEffect(() => {
    // If user is null (not authenticated), redirect to sign-in page
    if (user === null) {
      const currentPath = location.pathname + location.search + location.hash;
      const redirectParam = encodeURIComponent(currentPath);
      window.location.href = `/signin?redirect=${redirectParam}`;
    }
  }, [user, location]);

  // Show loading while redirecting unauthenticated users
  if (user === null) {
    return <Loading label="Redirecting to sign in..." />;
  }
  return (
    <AuthProvider user={user}>
      <Header />
      <Main id="main">
        <Content>
          <Suspense fallback={<Loading />}>
            <Outlet />
          </Suspense>
        </Content>
      </Main>
      <Footer />
    </AuthProvider>
  );
};
